"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArrowDownFilled = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

var defaultFill = 'var(--color-icon-fill)';
var StyledSvg = styled_components_1.default.svg(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  height: 0.25rem;\n  width: 0.375rem;\n"], ["\n  height: 0.25rem;\n  width: 0.375rem;\n"])));

function ArrowDownFilled(_a) {
  var className = _a.className,
      children = _a.children,
      _b = _a.fill,
      fill = _b === void 0 ? defaultFill : _b;
  return react_1.default.createElement(StyledSvg, {
    className: className,
    viewBox: "0 0 6 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, children, react_1.default.createElement("path", {
    d: "M0.240201 1.37321C0.177097 1.31062 0.141602 1.22542 0.141602 1.13654C0.141602 1.04766 0.177097 0.962461 0.240201 0.899872L0.373534 0.766538C0.436251 0.701433 0.523144 0.665228 0.613534 0.666538H5.38687C5.47726 0.665228 5.56415 0.701433 5.62687 0.766538L5.7602 0.899872C5.82331 0.962461 5.8588 1.04766 5.8588 1.13654C5.8588 1.22542 5.82331 1.31062 5.7602 1.37321L3.23353 3.89987C3.17305 3.96432 3.08859 4.00088 3.0002 4.00088C2.91181 4.00088 2.82736 3.96432 2.76687 3.89987L0.240201 1.37321Z",
    fill: fill
  }));
}

exports.ArrowDownFilled = ArrowDownFilled;
var templateObject_1;